import AdGroupList from 'common/pages/ad-group/AdGroupList'

export const AdGroupAdvList = (props) =>
    <AdGroupList {...props} mode={props.mode} agency={false} />